<template>
  <v-card class="elevation-12" :loading="loading">
    <v-toolbar
        color="primary"
        dark
        flat
    >
      <v-toolbar-title>{{ $t('addOrganizationForm.title') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-form class="pt-5">
        <v-text-field
            :label="$t('addOrganizationForm.labels.tin')"
            v-model="form.inn"
            type="text"
            maxlength="9"
            :counter="9"
            :error-messages="innErrors"
            @keyup="form.isInnExists = false"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.pinfl"
            :label="$t('addOrganizationForm.labels.pinfl')"
            type="text"
            maxlength="..."
        ></v-text-field>

        <v-text-field
            v-model="form.name"
            :label="$t('addOrganizationForm.labels.orgName')"
            type="text"
            maxlength="400"
            :counter="400"
            :error-messages="nameErrors"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.address"
            :label="$t('addOrganizationForm.labels.orgAddress')"
            type="text"
            maxlength="400"
            :counter="400"
            :error-messages="addressErrors"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.accountNumber"
            :label="$t('addOrganizationForm.labels.accountNumber')"
            type="text"
            maxlength="30"
            :counter="30"
            :error-messages="addressErrors"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.mfo"
            :label="$t('addOrganizationForm.labels.mfo')"
            type="text"
            maxlength="5"
            :counter="400"
            :error-messages="addressErrors"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.phoneNumber"
            :label="$t('addOrganizationForm.labels.phoneNumber')"
            type="text"
            maxlength="12"
            :counter="12"
            :error-messages="phoneNumberErrors"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.fullname"
            :label="$t('addOrganizationForm.labels.fullName')"
            type="text"
            maxlength="400"
            :counter="400"
            :error-messages="fullnameErrors"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.username"
            :label="$t('addOrganizationForm.labels.login')"
            type="text"
            maxlength="12"
            :counter="12"
            :error-messages="usernameErrors"
            @keyup="form.isUsernameExists = false"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.password"
            :label="$t('addOrganizationForm.labels.password')"
            type="password"
            :error-messages="passwordErrors"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.passwordRepeat"
            :label="$t('addOrganizationForm.labels.passwordRepeat')"
            type="password"
            :error-messages="passwordRepeatErrors"
            :disabled="isFormSuccess"
        />

        <v-text-field
            v-model="form.vatRegCode"
            :label="$t('addOrganizationForm.labels.vatCode')"
            type="text"
            maxlength="..."
        ></v-text-field>

        <v-text-field
            v-model="form.contractSum"
            :label="$t('addOrganizationForm.labels.contractSum')"
            type="number"
            step="0.01"
        ></v-text-field>

        <v-text-field
            v-model="form.sumForMail"
            :label="$t('addOrganizationForm.labels.sumForMail')"
            type="number"
            step="0.01"
        ></v-text-field>

        <v-text-field
            v-model="form.sumForOverPaged"
            :label="$t('addOrganizationForm.labels.sumForOverPaged')"
            type="number"
            step="0.01"
        ></v-text-field>

        <v-text-field
            v-model="form.contractNumber"
            :label="$t('addOrganizationForm.labels.contractNumber')"
            type="text"
            maxlength="400"
            :counter="400"
        />

        <v-spacer class="py-2"></v-spacer>

        <DateInput v-model="form.contractDateFrom"
                   :label="$t('addOrganizationForm.labels.contractDateFrom')"
                   :dense="true"
                   min-width="0"
                   max-width="80%"
        />

        <v-spacer class="py-2"></v-spacer>

        <DateInput v-model="form.contractDateTo"
                   :label="$t('addOrganizationForm.labels.contractDateTo')"
                   :dense="true"
                   min-width="0"
                   max-width="80%"
        />

        <v-spacer class="py-2"></v-spacer>

        <v-responsive>
          <v-row>
            <v-col cols="12" class="py-4">
              <v-autocomplete v-model="form.contractSignerUnitId"
                                :items="units"
                                :label="$t('addOrganizationForm.labels.contractSignerBranch')"
                                :dense="true"
                                :clearable="true"
                                item-text="name"
                                item-value="id"/>
            </v-col>
            <v-spacer/>
          </v-row>
        </v-responsive>

        <v-responsive>
          <v-row>
            <v-col cols="11">
              <v-autocomplete v-model="selectedBranch"
                                :items="branches"
                                :label="$t('addOrganizationForm.labels.branches')"
                                :dense="true"
                                :clearable="true"
                                item-text="branchName"
                                item-value="id"/>
            </v-col>
            <v-col cols="1" class="pl-0">
              <v-btn icon color="primary" @click="loadBranches">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-col>
            <p class="pl-3" style="color: #ff0e0e" v-if="showInnRequiredMessage">{{ $t('addOrganizationForm.messages.tinRequired') }}</p>
            <v-spacer/>
          </v-row>
        </v-responsive>

        <v-checkbox
            v-model="form.hasContractWithGlobalUnit"
            :label="$t('addOrganizationForm.checkboxes.hasGlobalContract')"
        ></v-checkbox>

        <v-checkbox
            v-model="form.isLtd"
            :label="$t('addOrganizationForm.checkboxes.isIndividual')"
        ></v-checkbox>

        <v-radio-group v-model="form.isActive">
          <template v-slot:label>
            <div><strong>{{ $t('addOrganizationForm.status.title') }}</strong></div>
          </template>
          <v-radio :value="true" color="success">
            <template v-slot:label>
              <div>{{ $t('addOrganizationForm.status.active') }}</div>
            </template>
          </v-radio>
          <v-radio :value="false" color="secondary">
            <template v-slot:label>
              <div>{{ $t('addOrganizationForm.status.inactive') }}</div>
            </template>
          </v-radio>
        </v-radio-group>

        <v-text class="red--text">
          {{ $t('addOrganizationForm.messages.fillSumsInSection') }}
        </v-text>

        <v-snackbar v-model="isRegistrationFailed"
                    :timeout="5000"
                    :top="true"
                    color="error"
        >
          {{ $t('addOrganizationForm.messages.registrationFailed') }}
        </v-snackbar>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="onCancelButtonClicked">{{ $t('addOrganizationForm.actions.cancel') }}</v-btn>
      <v-spacer/>
      <v-btn text color="primary" @click="onAddButtonClicked">{{ $t('addOrganizationForm.actions.add') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {maxLength, minLength, numeric, required, sameAs} from "vuelidate/lib/validators";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import OrganizationService from "@/services/organization.service";
import _ from "underscore";
import Mappers from "@/mappers";
import DateInput from "@/components/input/DateInput";
import BranchService from "@/services/branch.service";
import GlobalUnitService from "@/services/global.unit.service";

export default {
  name: "AddOrganizationComponent",
  data() {
    return {
      loading: false,
      isRegistrationFailed: false,
      showInnRequiredMessage: false,

      units: [],
      branches: [],
      selectedBranch: '',

      form: {
        companyInn: '',
        inn: '',
        name: '',
        address: '',
        accountNumber: '',
        mfo: '',
        phoneNumber: '998',
        fullname: '',
        username: '998',
        password: '',
        passwordRepeat: '',
        branch : {
          branchName: '',
          branchCode: ''
        },
        vatRegCode: '',
        pinfl: '',
        isLtd: false,
        contractSum: null,
        sumForMail: null,
        sumForOverPaged: null,

        contractNumber: '',
        contractDateFrom: null,
        contractDateTo: null,
        contractSignerUnitId: '',
        isActive: false,

        isInnExists: false,
        isUsernameExists: false,
        isOrganizationNameExists: false,
        hasContractWithGlobalUnit: false
      },

      filters: {
        inn: null,
        contractDateFrom: null,
        contractDateTo: null
      },
      filterContractDateFromMenu: false,
      filterContractDateFromDisplayValue: '',
      filterContractDateToMenu: false,
      filterContractDateToDisplayValue: '',

      isFormSuccess: false,
      isServerError: false
    }
  },
  components: {
    DateInput
  },
  computed: {
    innErrors() {
      const errors = []
      if (this.$v.form.inn.$dirty) {
        if (!this.$v.form.inn.required) {
          errors.push(this.$t('addOrganizationForm.errors.tinRequired'))
        } else {
          !this.$v.form.inn.numeric && errors.push(this.$t('addOrganizationForm.errors.tinFormat'))

          if (!this.$v.form.inn.minLength || !this.$v.form.inn.maxLength)
            errors.push(this.$t('addOrganizationForm.errors.tinLength'))
        }

        this.form.isInnExists && errors.push(this.$t('addOrganizationForm.errors.tinExists'))
      }

      return errors
    },
    nameErrors() {
      const errors = []

      if (this.$v.form.name.$dirty) {
        if (!this.$v.form.name.required) {
          errors.push(this.$t('addOrganizationForm.errors.nameRequired'))
        } else {
          !this.$v.form.name.maxLength && errors.push(this.$t('addOrganizationForm.errors.nameTooLong'))
        }
      }

      return errors
    },
    addressErrors() {
      const errors = []

      if (this.$v.form.address.$dirty) {
        if (!this.$v.form.address.required) {
          errors.push(this.$t('addOrganizationForm.errors.addressRequired'))
        } else {
          !this.$v.form.address.maxLength && errors.push(this.$t('addOrganizationForm.errors.addressTooLong'))
        }
      }

      return errors
    },
    accountNumberErrors() {
      const errors = []

      if (this.$v.form.accountNumber.$dirty) {
        if (!this.$v.form.accountNumber.required) {
          errors.push(this.$t('addOrganizationForm.errors.accountRequired'))
        } else {
          !this.$v.form.address.maxLength && errors.push(this.$t('addOrganizationForm.errors.accountTooLong'))
        }
      }

      return errors
    },
    mfoErrors() {
      const errors = []

      if (this.$v.form.mfo.$dirty) {
        if (!this.$v.form.mfo.required) {
          errors.push(this.$t('addOrganizationForm.errors.mfoRequired'))
        } else {
          !this.$v.form.address.maxLength && errors.push(this.$t('addOrganizationForm.errors.mfoTooLong'))
        }
      }

      return errors
    },
    phoneNumberErrors() {
      const errors = []
      if (this.$v.form.phoneNumber.$dirty) {
        if (!this.$v.form.phoneNumber.required) {
          errors.push(this.$t('addOrganizationForm.errors.phoneRequired'))
        } else {
          if (!this.$v.form.phoneNumber.numeric || !this.$v.form.phoneNumber.format)
            errors.push(this.$t('addOrganizationForm.errors.phoneFormat'))
          if (!this.$v.form.phoneNumber.minLength || !this.$v.form.phoneNumber.maxLength)
            errors.push(this.$t('addOrganizationForm.errors.phoneLength'))
        }
      }

      return errors
    },
    fullnameErrors() {
      const errors = []

      if (this.$v.form.fullname.$dirty) {
        if (!this.$v.form.fullname.required) {
          errors.push(this.$t('addOrganizationForm.errors.fullNameRequired'))
        } else {
          !this.$v.form.fullname.maxLength && errors.push(this.$t('addOrganizationForm.errors.fullNameTooLong'))
        }
      }

      return errors
    },
    usernameErrors() {
      const errors = []
      if (this.$v.form.username.$dirty) {
        if (!this.$v.form.username.required) {
          errors.push(this.$t('addOrganizationForm.errors.phoneRequired')) // Re-using phone error message
        } else {
          if (!this.$v.form.username.numeric || !this.$v.form.username.format)
            errors.push(this.$t('addOrganizationForm.errors.phoneFormat')) // Re-using phone error message
          if (!this.$v.form.username.minLength || !this.$v.form.username.maxLength)
            errors.push(this.$t('addOrganizationForm.errors.phoneLength')) // Re-using phone error message
        }

        this.form.isUsernameExists && errors.push(this.$t('addOrganizationForm.errors.loginExists'))
      }

      return errors
    },
    passwordErrors() {
      const errors = []

      if (this.$v.form.password.$dirty) {
        if (!this.$v.form.password.required) {
          errors.push(this.$t('addOrganizationForm.errors.passwordRequired'))
        } else {
          if (!this.$v.form.password.minLength)
            errors.push(this.$t('addOrganizationForm.errors.passwordTooShort'))
        }
      }

      return errors
    },
    passwordRepeatErrors() {
      const errors = []

      if (this.$v.form.passwordRepeat.$dirty) {
        if (!this.$v.form.passwordRepeat.required) {
          errors.push(this.$t('addOrganizationForm.errors.passwordRepeatRequired'))
        } else {
          if (!this.$v.form.passwordRepeat.sameAs) {
            errors.push(this.$t('addOrganizationForm.errors.passwordsDontMatch'))
          }
        }
      }

      return errors
    }
  },
  validations: {
    form: {
      inn: {
        required,
        numeric,
        minLength: minLength(9),
        maxLength: maxLength(9)
      },
      name: {
        required,
        maxLength: maxLength(400)
      },
      address: {
        required,
        maxLength: maxLength(400)
      },
      fullname: {
        required,
        maxLength: maxLength(400)
      },
      username: {
        required,
        maxLength: maxLength(12),
        minLength: minLength(12),
        numeric,
        format(value) {
          return /^998\d{9}$/.test(value);
        }
      },
      phoneNumber: {
        required,
        maxLength: maxLength(12),
        minLength: minLength(12),
        numeric,
        format(value) {
          return /^998\d{9}$/.test(value);
        }
      },
      password: {
        required,
        minLength: minLength(8),
      },
      passwordRepeat: {
        required,
        sameAs: sameAs(function () {
          return this.form.password
        })
      }
    }
  },
  methods: {
    loadUnits() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      GlobalUnitService.getUnits({inn: this.$store.getters.inn})
          .then(response => {
            this.units = _.map(response.data, o => {
              return Mappers.mapUnit(o)
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadBranches() {
      if (this.form.inn.length === 9) {
        this.$store.dispatch(LAYOUT_LOADING_START)
        BranchService.getBranches({inn: this.form.companyInn})
            .then(response => {
              this.branches = _.map(response.data, b => {
                return Mappers.mapBranch(b)
              })
            })
            .finally(() => {
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
      else{
        this.showInnRequiredMessage = true;
      }
    },
    clear() {
      this.$v.$reset()
      this.form.inn = ''
      this.form.name = ''
      this.form.address = ''
      this.form.accountNumber = ''
      this.form.mfo = ''
      this.form.phoneNumber = ''
      this.form.fullname = ''
      this.form.username = ''
      this.form.password = ''
      this.form.passwordRepeat = ''
      this.form.branch.branchName = ''
      this.form.branch.branchCode = ''
      this.form.vatRegCode = ''
      this.form.pinfl = ''
      this.form.isLtd = false
      this.form.hasContractWithGlobalUnit = false
      this.form.contractSum = null,
      this.form.sumForMail = null,
      this.form.sumForOverPaged = null,


      this.form.contractNumber = ''
      this.form.contractDateFrom = null
      this.form.contractDateTo = null
      this.form.contractSignerUnitId = ''

      this.form.isActive = false

      this.form.isInnExists = false
      this.form.isUsernameExists = false
      this.form.isOrganizationNameExists = false
    },
    onCancelButtonClicked() {
      this.clear()
      this.$emit('cancel')
    },
    onAddButtonClicked() {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.loading = true;
        this.$store.dispatch(LAYOUT_LOADING_START)

        this.form.isOrganizationNameExists = false
        this.isServerError = false

        OrganizationService.checkOrganization(this.form.name)
            .then(response => {
              if (response.data.IsExists) {
                this.form.isOrganizationNameExists = true
                this.loading = false
                this.$store.dispatch(LAYOUT_LOADING_STOP)
              } else {
                OrganizationService.addOrganization({
                  inn: this.form.inn,
                  name: this.form.name,
                  address: this.form.address,
                  accountNumber: this.form.accountNumber,
                  mfo: this.form.mfo,
                  phoneNumber: this.form.phoneNumber,
                  vatRegCode: this.form.vatRegCode,
                  branchCode: this.form.branch.branchCode,
                  branchName: this.form.branch.branchName,
                  isLtd: this.form.isLtd,
                  pinfl: this.form.pinfl,
                  contractSum: this.form.contractSum,
                  sumForMail: this.form.sumForMail,
                  sumForOverPaged: this.form.sumForOverPaged,
                  userFullName: this.form.fullname,
                  username: this.form.username,
                  password: this.form.password,
                  contractNumber: this.form.contractNumber,
                  contractDateFrom: this.form.contractDateFrom,
                  contractDateTo: this.form.contractDateTo,
                  contractSignerUnitId: this.form.contractSignerUnitId,
                  isActive: this.form.isActive,
                  hasContractWithGlobalUnit: this.form.hasContractWithGlobalUnit
                })
                    .then(() => {
                      this.clear()
                      this.$emit('added')
                    }, () => {
                      this.isServerError = true
                    })
                    .finally(() => {
                      this.loading = false
                      this.$store.dispatch(LAYOUT_LOADING_STOP)
                    })
              }
            }, () => {
              this.loading = false
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
    }
  },
  created() {
    this.loadUnits()
  },
  watch: {
    selectedBranch(newVal) {
      const selectedItem = this.branches.find(item => item.id === newVal);
      this.form.branch.branchName = selectedItem.branchName;
      this.form.branch.branchCode = selectedItem.branchCode;
    },
    filters: {
      deep: true,
      handler() {
        //this.load()
      }
    },
    'form.inn'(newInnValue) {
      this.showInnRequiredMessage = false;
      this.form.companyInn = newInnValue;
      this.loadBranches();
    },
  }
}
</script>

<style scoped>

</style>